<template>
  <div>
    <button class="btn-small solidgreen modal-trigger" :href="'#modalProblem'+problem.device_id">{{$t('menu.buttons.edit')}}</button>
    <div :id="'modalProblem'+problem.device_id" class="modal">
      <div class="modal-content">
        <h5>{{$t('inspection.editing_problem')}} {{problem.number}}</h5>
         <div class="row">
            <div class="col s12">
              <fieldset>
                 <label>
                  <input :name="'unreadable'+uid" id="unreadable" value="2" type="radio" v-model="problem.kind"/>
                  <span>{{$t('inspection.unreadable_code')}}</span>
                </label>
                 <label>
                  <input :name="'not_found'+uid" id="not_found" value="1" type="radio" v-model="problem.kind"/>
                  <span>{{$t('inspection.not_found')}}</span>
                </label>
                
                 <label>
                  <input :name="'unavailable'+uid" id="unavailable" value="3" type="radio" v-model="problem.kind"/>
                  <span>{{$t('inspection.unavailable')}}</span>
                </label>
                 <label>
                  <input :name="'totaled'+uid" id="totaled" value="5" type="radio" v-model="problem.kind"/>
                  <span>{{$t('inspection.destroyed')}}</span>
                </label>
                  <label>
                  <input :name="'temporary_disabled'+uid" id="temporary_disabled" value="6" type="radio" v-model="problem.kind"/>
                  <span>{{$t('inspection.temporary_disabled')}}</span>
                </label>
              </fieldset>
            </div>
          </div>
          <div class="row">
            <div class="col s12">
              <textarea v-model="problem.inactivate_cause" :placeholder="$t('inspection.notices')"></textarea>
            </div>
          </div>
        </div>
      <div class="modal-footer">
        <button class="modal-close btn-small solidgreen">{{$t('menu.buttons.save')}}</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      device: {},
      criteria_dict: {},
      criterium: {},
      uid: _.uniqueId("deviceInspection"),
      problem_kinds: ["", this.$t('inspection.not_found'), this.$t('inspection.unreadable_code'), this.$t('inspection.unavailable'), this.$t('inspection.need_remove'), this.$t('inspection.destroyed'), this.$t('inspection.temporary_disabled')],
    }
  },
  props: {
    problem: Object, 
    dev_type: Object,
    devices: Array
  },
  mounted() {
    var elemss = this.$el.querySelectorAll('.modal');
    this.instance = M.Modal.init(elemss, {});
  },
  methods: {
  },
  computed: {
  }
}
</script>
<style scoped>
  select {
    display: block;
  }
  .modal{
    border: 5px solid #00CC66;
    border-radius: 15px;
  }
  h5{
    font-size: 15px;
    text-transform: uppercase;
  }
  label{
    padding: 10px;
    margin: 5px;
    border: 2px solid rgb(140, 140, 140);
    border-radius: 5px;
  }
  label:has(input:checked){
    border: 2px solid #00CC66 !important;
  }
  [type="checkbox"]+span:not(.lever):before {
      top: 0px;
      left: 0px;
      margin: 4px;
      width: 16px;
      height: 16px;
      border: 2px solid rgb(140, 140, 140);
      border-radius: 50%;
      -webkit-transform: rotate(40deg);
      transform: rotate(0deg) !important;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      -webkit-transform-origin: 100% 100%;
      transform-origin: 100% 100%;
  }
  [type="checkbox"]:checked+span:not(.lever):before {
      top: 0px;
      left: 0px;
      border: 2px solid #00CC66;
      line-height: 12px;
      font-family: 'Material Icons';
      color: #00CC66;
      content: "\e5ca";
      border-radius: 50%;
      -webkit-transform: rotate(40deg);
      transform: rotate(0deg) !important;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      -webkit-transform-origin: 100% 100%;
      transform-origin: 100% 100%;
      font-size: 12px;
  }
  [type="radio"]:checked+span:after{
    border: 2px solid #00CC66;
    background-color: #fff;
    font-family: 'Material Icons';
    color: #00CC66;
    content: "\e5ca";
    line-height: 12px;
    font-size: 12px;
  }
  fieldset{
    padding-top: 15px;
    padding-bottom: 15px;
    border-radius: 5px;
  }
  .removephoto {
      vertical-align: top;
      float: right;
      background-color: black;
      border: none;
      border-radius: 15px;
  }
  .removephoto i {
      color: white;
  }
</style>